import React, { useEffect } from "react";
import CollectionContainer from '../Collections/CollectionContainer'
import FilterBox from '../FilterBox/FilterBox'
import TextField from '@material-ui/core/TextField'
import FilterButton from './Button'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import BaseLayout from "../BaseLayout/index";

//Material Components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Button } from "@material-ui/core";


const useStyles = makeStyles(({ breakpoints, spacing }, theme) => ({
  root: {
    flexGrow: 1,
    //background: "#000714",
  },
}));

function Collection() {
  const classes = useStyles();
  
  return (
    <BaseLayout className={classes.root}>
      <div className='collection-container'>
        <Grid container style={{height:'100vh'}}>
          <Grid style={{backgroundColor:'black'}} item xs={3}>
            <FilterBox/>
          </Grid>
          <Grid item xs={9}>
            <div className="search-box">
              <Grid container>
                <Grid item xs={7}>
                  <div className="button-box">
                    <FilterButton filter = 'featured'/>
                    <FilterButton filter = 'popular'/>
                    <FilterButton filter = 'volume'/>
                    <FilterButton filter = 'cheapest'/>
                  </div>
                </Grid>
                <Grid item xs={5}>
                <div className="search-bar">
                  <TextField size='small'
                    InputProps={{className:'input-field'}}
                    onFocus="false"
                    style=
                    {{width:'250px',
                    float:'left',
                    marginLeft:'30px',
                    marginTop:'20px',
                    backgroundColor:'#0E0E0E',
                    borderRadius:'10px',
                    height:'40px',
                    
                    marginBottom:'30px'}} 
                    label="SEARCH" 
                    variant="outlined" 
                    InputLabelProps={{className:"text-label"}}/>
                </div>
                </Grid>
              </Grid>
            </div>  
            <CollectionContainer/>
            {/* <div className="page-button-box">
              <Button 
                size="small" 
                variant="outlined"
                style={{backgroundColor:'#0E0E0E',
                border:'2px solid black',
                borderRadius:'40px',
                width:'20px',}}>
                <ChevronLeftIcon style={{color:'white'}}/>
              </Button>
              <Button 
                size="small" 
                variant="outlined"
                style={{
                  backgroundColor:'#0E0E0E',
                  border:'2px solid black',
                  borderRadius:'40px',
                  width:'20px',
                }}
              >
                <ChevronRightIcon style={{color:'white'}}/>
              </Button>
            </div> */}
          </Grid>
        </Grid>
        
      </div>
    </BaseLayout>
  );
}

export default Collection;
